/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  MemoryStoreMount,
  MemoryStoreMount$inboundSchema,
  MemoryStoreMount$Outbound,
  MemoryStoreMount$outboundSchema,
} from "./memorystoremount.js";
import {
  ShellNetworkPolicy,
  ShellNetworkPolicy$inboundSchema,
  ShellNetworkPolicy$Outbound,
  ShellNetworkPolicy$outboundSchema,
} from "./shellnetworkpolicy.js";
import {
  SkillEntry,
  SkillEntry$inboundSchema,
  SkillEntry$Outbound,
  SkillEntry$outboundSchema,
} from "./skillentry.js";

export type ShellEnvironmentContainerAuto = {
  type: "container_auto";
  networkPolicy?: ShellNetworkPolicy | undefined;
  /**
   * Skills to inject into the container's /skills directory.
   */
  skills?: Array<SkillEntry> | undefined;
  /**
   * Memory stores to mount into the container under /mnt/memory.
   */
  memoryStores?: Array<MemoryStoreMount> | undefined;
};

/** @internal */
export const ShellEnvironmentContainerAuto$inboundSchema: z.ZodType<
  ShellEnvironmentContainerAuto,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("container_auto"),
  network_policy: ShellNetworkPolicy$inboundSchema.optional(),
  skills: z.array(SkillEntry$inboundSchema).optional(),
  memory_stores: z.array(MemoryStoreMount$inboundSchema).optional(),
}).transform((v) => {
  return remap$(v, {
    "network_policy": "networkPolicy",
    "memory_stores": "memoryStores",
  });
});
/** @internal */
export type ShellEnvironmentContainerAuto$Outbound = {
  type: "container_auto";
  network_policy?: ShellNetworkPolicy$Outbound | undefined;
  skills?: Array<SkillEntry$Outbound> | undefined;
  memory_stores?: Array<MemoryStoreMount$Outbound> | undefined;
};

/** @internal */
export const ShellEnvironmentContainerAuto$outboundSchema: z.ZodType<
  ShellEnvironmentContainerAuto$Outbound,
  z.ZodTypeDef,
  ShellEnvironmentContainerAuto
> = z.object({
  type: z.literal("container_auto"),
  networkPolicy: ShellNetworkPolicy$outboundSchema.optional(),
  skills: z.array(SkillEntry$outboundSchema).optional(),
  memoryStores: z.array(MemoryStoreMount$outboundSchema).optional(),
}).transform((v) => {
  return remap$(v, {
    networkPolicy: "network_policy",
    memoryStores: "memory_stores",
  });
});

export function shellEnvironmentContainerAutoToJSON(
  shellEnvironmentContainerAuto: ShellEnvironmentContainerAuto,
): string {
  return JSON.stringify(
    ShellEnvironmentContainerAuto$outboundSchema.parse(
      shellEnvironmentContainerAuto,
    ),
  );
}
export function shellEnvironmentContainerAutoFromJSON(
  jsonString: string,
): SafeParseResult<ShellEnvironmentContainerAuto, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ShellEnvironmentContainerAuto$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ShellEnvironmentContainerAuto' from JSON`,
  );
}
